import Vue from 'vue';
import xss from 'xss';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './assets/reset.less';
import toast from '@/components/common/toast/toast';
import config from '@/config';

Vue.config.productionTip = false;
Vue.prototype.$xss = xss;
Vue.prototype.$toast = toast;

// 开启移动端调试
//if (window.navigator.userAgent.includes('Mobile')) {
if ((config.ENV === 'sit' || config.ENV.includes('pre')) && window.navigator.userAgent.includes('Mobile')) {
  import('vconsole').then((module) => {
    const VConsole = module.default;
    /* eslint-disable*/
    new VConsole();
  });
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
